import FW from '../fw/fw';
import Logger from '../fw/logger';
import ListHelpers from './list-helpers';


export default class Related {

  #rmp;
  #currentRelatedIndex = 0;
  #relatedOnSrcChangedLoadAdFn = null;
  #relatedOnSrcChangeErrorFn = null;
  #filteredRelatedList = [];

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get currentRelatedIndex() {
    return this.#currentRelatedIndex;
  }

  get relatedList() {
    return this.#filteredRelatedList;
  }

  #updateSkipPreview() {
    this.#rmp.dom.relatedSkipPreview.classList.remove('rmp-force-show');
    let nextIndex = this.#currentRelatedIndex + 1;
    if (!this.#filteredRelatedList[nextIndex]) {
      nextIndex = 0;
    }
    this.#rmp.dom.relatedSkipImg.src = this.#filteredRelatedList[nextIndex].contentMetadata.thumbnail;
    FW.setText(this.#rmp.dom.relatedSkipText, this.#filteredRelatedList[nextIndex].contentMetadata.title);
  }

  #relatedOnSrcChangedLoadAd() {
    this.#rmp.off('srcchanged', this.#relatedOnSrcChangedLoadAdFn);
    this.#rmp.off('error', this.#relatedOnSrcChangeErrorFn);
    this.#rmp.dispatch('relateditem');
    if (FW.isValidCCFiles(this.#rmp.ccFiles)) {
      this.#rmp.captionsList = this.#rmp.ccFiles;
    }
    if (this.#rmp.relatedCallback === null && this.#rmp.ads && this.#rmp.adTagUrl) {
      this.#rmp.loadAds(this.#rmp.adTagUrl, ['internal']).catch(error => {
        this.#rmp.rmpUtils.warning(1020, error);
        this.#rmp.rmpUtils.playPromise();
      });
    }
    if (this.#rmp.chaptersLoc) {
      this.#rmp.chapters = this.#rmp.chaptersLoc;
    }
  }

  #relatedOnSrcChangeError() {
    this.#rmp.off('srcchanged', this.#relatedOnSrcChangedLoadAdFn);
    this.#rmp.off('error', this.#relatedOnSrcChangeErrorFn);
  }

  #setRelatedSrcWithOptionalDrm(newItem) {
    if (typeof newItem.shakaRequestConfiguration === 'object') {
      this.#rmp.shakaRequestFilterConfiguration = newItem.shakaRequestConfiguration;
    }
    if (typeof newItem.shakaDrm === 'object') {
      if (typeof newItem.shakaRequestConfiguration === 'undefined') {
        this.#rmp.shakaRequestFilterConfiguration = {};
      }
      this.#rmp.shakaDrmConfiguration = newItem.shakaDrm;
    }
    this.#rmp.setSrc(newItem.src).catch(error => {
      this.#rmp.rmpUtils.warning(1025, error);
    });
    // update active item in wall
    this.#updateActiveItemInWall();
  }

  #setRelatedSrc() {
    if (this.#filteredRelatedList[this.#currentRelatedIndex]) {
      const newItem = this.#filteredRelatedList[this.#currentRelatedIndex];
      ListHelpers.listParsing.call(this.#rmp, newItem);
      this.#rmp.rmpUIManagement.hideCentralPlay();
      if (!this.#rmp.rmpPlaybackManagement.playerInitialized) {
        this.#setRelatedSrcWithOptionalDrm(newItem);
      } else {
        this.#rmp.on('srcchanged', this.#relatedOnSrcChangedLoadAdFn);
        this.#rmp.on('error', this.#relatedOnSrcChangeErrorFn);
        this.#setRelatedSrcWithOptionalDrm(newItem);
      }
      this.#updateSkipPreview();
      if (newItem.seekBarThumbnailsLoc) {
        this.#rmp.thumbnails = newItem.seekBarThumbnailsLoc;
      } else if (this.#rmp.rmpThumbnails) {
        this.#rmp.rmpThumbnails.destroy();
      }
      if (newItem.chaptersLoc) {
        this.#rmp.chaptersLoc = newItem.chaptersLoc;
      } else if (this.#rmp.rmpChapters) {
        this.#rmp.rmpChapters.destroy();
      }
      const hasInitLogo = this.#rmp.dom.container.querySelector('.rmp-logo');
      if (newItem.logo) {
        this.#rmp.logoConfiguration = newItem.logo;
      } else if (hasInitLogo) {
        this.#rmp.logo.imgUri = '';
        this.#rmp.logoConfiguration = this.#rmp.logo;
      }
      if (newItem.sharingUrl) {
        this.#rmp.sharingData = {
          url: newItem.sharingUrl,
          code: ''
        };
      }
      if (newItem.sharingCode) {
        this.#rmp.sharingData = {
          url: '',
          code: newItem.sharingCode
        };
      }
    }
  }

  #appendRelatedItem(index) {
    // wrapper 
    if (this.#filteredRelatedList[index]) {
      const rtl = this.#rmp.rtl;
      const item = this.#filteredRelatedList[index];
      const itemElement = FW.createElement(
        'button',
        'rmp-button rmp-related-item',
        null,
        null
      );
      this.#rmp.rmpAccessible.button(itemElement, item.contentMetadata.title, true);
      // poster
      const img = FW.createElement('img', 'rmp-related-thumbnail');
      img.alt = '';
      img.src = item.contentMetadata.thumbnail;
      itemElement.appendChild(img);
      // title
      const title = FW.createElement('div', 'rmp-related-title', null, rtl);
      title.innerHTML = item.contentMetadata.title;
      itemElement.appendChild(title);
      // duration
      if (item.contentMetadata.duration) {
        const duration = FW.createElement('div', 'rmp-related-duration', item.contentMetadata.duration, rtl);
        itemElement.appendChild(duration);
      }
      // wire UI
      const onLoadRelatedItem = this.loadRelatedItem.bind(this, index);
      FW.addEvents(['touchend', 'click'], itemElement, onLoadRelatedItem);

      // append to overlay
      this.#rmp.dom.relatedOverlayLevelsArea.appendChild(itemElement);
    }
  }

  #updateActiveItemInWall() {
    const relatedItems = this.#rmp.dom.relatedOverlayLevelsArea.querySelectorAll('.rmp-related-item');
    if (relatedItems.length > 0) {
      const currentRelatedIndex = this.#rmp.getRelatedItem();
      for (let i = 0, len = relatedItems.length; i < len; i++) {
        const relatedItem = relatedItems[i];
        relatedItem.classList.remove('rmp-related-item-active');
        if (currentRelatedIndex === i) {
          relatedItem.classList.add('rmp-related-item-active');
        }
      }
    }
  }

  #setUpRelatedUI() {
    // append related className
    this.#rmp.dom.container.classList.add('rmp-related-ui');
    // append module
    this.#rmp.rmpModuleManagement.appendToModuleBar('related');
    this.#rmp.rmpModuleManagement.appendOverlay('related');
    this.#rmp.dom.relatedOverlayLevelsArea.classList.add('rmp-related-wall');
    // append each item in related list
    for (let i = 0, len = this.#filteredRelatedList.length; i < len; i++) {
      this.#appendRelatedItem(i);
    }
    this.#updateActiveItemInWall();
  }

  #skipRelatedInteraction(event) {
    FW.eventStopPrevent(event);
    this.loadRelatedItem(this.#currentRelatedIndex + 1);
  }

  #appendRelatedSkipButton() {
    const upNextHintLabel = this.#rmp.labels.hint.upNext;
    let nextIndex = this.#currentRelatedIndex + 1;
    if (typeof this.#filteredRelatedList[nextIndex] === 'undefined') {
      nextIndex = 0;
    }
    // skip button into control bar
    if (this.#rmp.dom.controlBar) {
      this.#rmp.dom.relatedSkip = FW.createElement(
        'button',
        'rmp-button rmp-related-skip-next rmp-i rmp-i-skip-next',
        null,
        null
      );
      this.#rmp.rmpAccessible.button(this.#rmp.dom.relatedSkip, upNextHintLabel, true);

      const skipInteractionFn = this.#skipRelatedInteraction.bind(this);
      FW.addEvents(['touchend', 'click'], this.#rmp.dom.relatedSkip, skipInteractionFn);
      FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom.relatedSkip, this.#rmp.dom.time);

      // append skip preview overlay
      this.#rmp.dom.relatedSkipPreview = FW.createElement('div', 'rmp-related-skip-preview');
      FW.addEvents(['touchend', 'click'], this.#rmp.dom.relatedSkipPreview, skipInteractionFn);
      this.#rmp.dom.relatedSkip.appendChild(this.#rmp.dom.relatedSkipPreview);

      // skip overlay image
      this.#rmp.dom.relatedSkipImg = FW.createElement('img', 'rmp-related-skip-preview-img');
      this.#rmp.dom.relatedSkipImg.alt = upNextHintLabel;
      this.#rmp.dom.relatedSkipImg.src = this.#filteredRelatedList[nextIndex].contentMetadata.thumbnail;
      this.#rmp.dom.relatedSkipPreview.appendChild(this.#rmp.dom.relatedSkipImg);
      // skip overlay title 
      this.#rmp.dom.relatedSkipText = FW.createElement(
        'div',
        'rmp-related-skip-preview-title rmp-color-bg',
        this.#filteredRelatedList[nextIndex].contentMetadata.title
      );
      this.#rmp.dom.relatedSkipPreview.appendChild(this.#rmp.dom.relatedSkipText);
      // skip overlay up next text
      const skipUpNext = FW.createElement('div', 'rmp-related-skip-preview-up-next rmp-color-bg', upNextHintLabel, this.#rmp.rtl);
      this.#rmp.dom.relatedSkipPreview.appendChild(skipUpNext);
      // on mouseenter show preview - on touch device - do nothing
      if (!this.#rmp.isMobile) {
        this.#rmp.dom.relatedSkip.addEventListener('mouseenter', event => {
          if (event) {
            event.stopPropagation();
          }
          this.#rmp.forceResetTimer = true;
          FW.fadeIn(this.#rmp.dom.relatedSkipPreview);
        });
        this.#rmp.dom.relatedSkip.addEventListener('mouseleave', event => {
          if (event) {
            event.stopPropagation();
          }
          this.#rmp.forceResetTimer = false;
          FW.fadeOut(this.#rmp.dom.relatedSkipPreview);
        });
      }
    }
  }

  #initialRelatedParsing(related) {
    this.#filteredRelatedList = ListHelpers.filterList(related);
    if (this.#filteredRelatedList.length > 0 && this.#filteredRelatedList[0]) {
      ListHelpers.initialListParsing.call(this.#rmp, this.#filteredRelatedList[0]);
      this.#relatedOnSrcChangedLoadAdFn = this.#relatedOnSrcChangedLoadAd.bind(this);
      this.#relatedOnSrcChangeErrorFn = this.#relatedOnSrcChangeError.bind(this);
      this.#rmp.rmpUtils.detectSrc();
      this.#rmp.rmpInitManagement.selectStreamingProtocol();
      this.#setUpRelatedUI();
      this.#appendRelatedSkipButton();
    } else {
      this.#rmp.rmpUtils.error(713);
      this.#rmp.rejectPromise('init', this.#rmp.errorData);
    }
  }

  #loadRelatedList(index) {
    this.#currentRelatedIndex = index;
    if (typeof this.#filteredRelatedList[this.#currentRelatedIndex] === 'undefined') {
      this.#currentRelatedIndex = 0;
    }
    if (this.#filteredRelatedList[this.#currentRelatedIndex].related) {
      this.setInternalRelatedData(this.#filteredRelatedList[this.#currentRelatedIndex].related);
    } else {
      this.#setRelatedSrc();
    }
  }

  #updateRelatedList(related, resolve, reject) {
    this.#filteredRelatedList = ListHelpers.filterList(related);
    if (this.#filteredRelatedList.length > 0 && this.#filteredRelatedList[0]) {
      this.#currentRelatedIndex = 0;
      // clear related wall
      const relatedItemElements = this.#rmp.dom.relatedOverlayLevelsArea.querySelectorAll('.rmp-related-item');
      if (relatedItemElements.length > 0) {
        for (let i = 0, len = relatedItemElements.length; i < len; i++) {
          FW.removeElement(relatedItemElements[i]);
        }
      }
      // recreate related wall
      for (let i = 0, len = this.#filteredRelatedList.length; i < len; i++) {
        this.#appendRelatedItem(i);
      }
      this.#setRelatedSrc();
      resolve();
    } else {
      this.#rmp.rmpUtils.error(713);
      reject(this.#rmp.errorData);
    }
  }

  setInternalRelatedData(relatedData) {
    return new Promise((resolve, reject) => {
      if (Array.isArray(relatedData)) {
        this.#updateRelatedList(relatedData, resolve, reject);
      } else if (typeof relatedData === 'string') {
        this.#rmp.relatedLoc = relatedData;
        FW.ajax(this.#rmp.relatedLoc, this.#rmp.ajaxWithCredentials, 'GET').
          then(data => {
            Logger.print('related', 'loaded new JSON related at ' + this.#rmp.relatedLoc);
            let jsonData;
            try {
              jsonData = JSON.parse(data);
            } catch (error) {
              this.#rmp.rmpUtils.error(711, error);
              reject(this.#rmp.errorData);
              return;
            }
            if (Array.isArray(jsonData.playlist)) {
              this.#updateRelatedList(jsonData.playlist, resolve, reject);
            } else {
              this.#rmp.rmpUtils.error(712);
              reject(this.#rmp.errorData);
            }
          }).catch(error => {
            this.#rmp.rmpUtils.error(710, error);
            reject(this.#rmp.errorData);
          });
      }
    });
  }

  relatedCallbackPromise() {
    return new Promise((resolve, reject) => {
      this.#rmp.relatedCallback().then(() => {
        Logger.print('related', 'relatedCallback has resolved');
        resolve();
      }).catch(warning => {
        this.#rmp.rmpUtils.warning(7010, warning);
        reject(this.#rmp.warningData);
      });
    });
  }

  loadRelatedItem(index, event) {
    FW.eventStopPrevent(event);
    if (this.#rmp.changingSrc) {
      Logger.print('related', 'previous item currently loading - new request is aborted');
      return;
    }
    if (this.#rmp.getRelatedItem() === index) {
      Logger.print('related', 'new item is current item - exit');
      return;
    }
    if (this.#rmp.relatedCallback !== null) {
      this.relatedCallbackPromise().then(() => {
        this.#loadRelatedList(index);
      }).catch(warning => {
        console.warn(warning);
        this.#loadRelatedList(index);
      });
    } else {
      this.#loadRelatedList(index);
    }
  }

  init() {
    Logger.print('related', 'setting up related layout');
    if (this.#rmp.relatedLoc === '') {
      this.#initialRelatedParsing(this.#rmp.relatedData);
    } else {
      FW.ajax(this.#rmp.relatedLoc, this.#rmp.ajaxWithCredentials, 'GET').
        then(data => {
          Logger.print('related', 'loaded JSON related at ' + this.#rmp.relatedLoc);
          let jsonData;
          try {
            jsonData = JSON.parse(data);
          } catch (error) {
            this.#rmp.rmpUtils.error(711, error);
            this.#rmp.rejectPromise('init', this.#rmp.errorData);
            return;
          }
          if (Array.isArray(jsonData.playlist)) {
            this.#initialRelatedParsing(jsonData.playlist);
          } else {
            this.#rmp.rmpUtils.error(712);
            this.#rmp.rejectPromise('init', this.#rmp.errorData);
          }
        }).catch(error => {
          this.#rmp.rmpUtils.error(710, error);
          this.#rmp.rejectPromise('init', this.#rmp.errorData);
        });
    }
  }

}
